import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm, LoadingSpinner } from '../components';
import { useAuth } from '../contexts/AuthContext';
import { propertyApi } from '../services';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [checkingProperties, setCheckingProperties] = useState(false);
  const isRegistrationEnabled =
    import.meta.env.VITE_REGISTRATION_ENABLED !== 'false';

  useEffect(() => {
    console.log('Registration Enabled:', isRegistrationEnabled);
    console.log('Raw Env Value:', import.meta.env.VITE_REGISTRATION_ENABLED);
  }, [isRegistrationEnabled]);
  useEffect(() => {
    const checkRedirect = async () => {
      if (isAuthenticated) {
        setCheckingProperties(true);
        try {
          const properties = await propertyApi.getAll();
          if (properties.length === 0) {
            navigate('/welcome');
          } else {
            navigate('/dashboard');
          }
        } catch {
          navigate('/dashboard');
        } finally {
          setCheckingProperties(false);
        }
      }
    };
    checkRedirect();
  }, [isAuthenticated, navigate]);

  const handleLoginSuccess = async () => {
    setCheckingProperties(true);
    try {
      const properties = await propertyApi.getAll();
      if (properties.length === 0) {
        navigate('/welcome');
      } else {
        navigate('/dashboard');
      }
    } catch {
      navigate('/dashboard');
    } finally {
      setCheckingProperties(false);
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {checkingProperties ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
              padding: '40px',
            }}
          >
            <LoadingSpinner size="medium" />
            <p
              style={{
                color: 'var(--Grey-1, #F3F1FF)',
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Lade Immobiliendaten...
            </p>
          </div>
        ) : (
          <>
            <LoginForm
              onSuccess={handleLoginSuccess}
              onForgotPassword={handleForgotPassword}
            />

            <div className="login-footer">
              {isRegistrationEnabled ? (
                <p>
                  Don't have an account?{' '}
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => navigate('/register')}
                  >
                    Sign up here
                  </button>
                </p>
              ) : (
                <p
                  style={{
                    opacity: 0.8,
                    fontSize: '0.85rem',
                    color: '#e0dbff',
                    fontStyle: 'italic',
                  }}
                >
                  Valuera Closed Alpha: Registration is invitation-only. Please
                  log in with your assigned test credentials.
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
